import { useMemo } from 'react'
import { v4 as uuid } from 'uuid'

export default function useUuid(length = 8, deps = []) {
  return useMemo(() => uuid().substring(0, length), deps)
}
